document.addEventListener('DOMContentLoaded', function() {
    const burger = document.querySelector('.header_burger');
    const header = document.querySelector('.header_wrapper');
    const wrapperList = document.querySelector('.header_wrapper-list');
    const menuText = document.querySelector('.header_burger .menu');

    if (!burger || !header || !wrapperList || !menuText) {
        console.error('Один из элементов не найден!');
        return;
    }

    function toggleMenu() {
        const isActive = burger.classList.contains('active');

        if (isActive) {
            burger.classList.remove('active');
            header.classList.remove('active');
            wrapperList.classList.remove('active');
            document.body.style.overflow = '';

            setTimeout(() => {
                menuText.style.opacity = '1';
                menuText.style.visibility = 'visible';
            }, 50);

        } else {
            menuText.style.opacity = '0';
            menuText.style.visibility = 'hidden';

            setTimeout(() => {
                burger.classList.add('active');
                header.classList.add('active');
                wrapperList.classList.add('active');
                document.body.style.overflow = 'hidden';
            }, 50);
        }
    }

    menuText.style.transition = 'opacity 0.3s, visibility 0.3s';

    burger.addEventListener('click', toggleMenu);

    const menuLinks = wrapperList.querySelectorAll('a');
    menuLinks.forEach(link => {
        link.addEventListener('click', function() {
            burger.classList.remove('active');
            header.classList.remove('active');
            wrapperList.classList.remove('active');
            document.body.style.overflow = '';

            setTimeout(() => {
                menuText.style.opacity = '1';
                menuText.style.visibility = 'visible';
            }, 300);
        });
    });
});



document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');

      if (href === '#') return;

      const targetElement = document.querySelector(href);
      if (!targetElement) return;

      e.preventDefault();

      window.scrollTo({
        top: targetElement.offsetTop - 100,
        behavior: 'smooth'
      });
    });
  });
});
